import React, { useContext, useState } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const WaybillContext = React.createContext();


export const WaybillProvider = ({ children }) => {


    const { usertoken, btoken, stoken } = useUserContext();


    let data = { usertoken, btoken, stoken };

    const {
        loading: waybillLoading, data: waybillData, fetchData: getWaybillData
    } = useFetch('/wayBill.fetch', data);


    const [showAddWaybill, setShowAddWaybill] = useState(false);
    const CloseAddWaybill = () => setShowAddWaybill(false);
    const openAddWaybill = () => setShowAddWaybill(true);



    return (
        <WaybillContext.Provider value={{

            showAddWaybill, CloseAddWaybill, openAddWaybill,


            waybillLoading, waybillData, getWaybillData,


        }}>
            {children}
        </WaybillContext.Provider>
    );
};

// make sure use
export const useWaybillContext = () => {
    return useContext(WaybillContext);
};
